<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render(h, context) {
    const { icon, title } = context.props
    const vnodes = []

    if (icon) {
      // <svg-icon icon-class={icon}/>
      vnodes.push(<i class = {icon}></i>)
    }

    if (title) {
      vnodes.push(<span slot='title' style="display:inline-block;line-height: normal;white-space:normal;">{(title)}</span>)
    }
    return vnodes
  }
}
</script>
